export default __webpack_public_path__ + "static/sugar-stack-logo-with-tagline-white-0787a2f199ee0f4ddb6e70593c67a9ce.svg";